import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { cloneElement } from 'react';
import Box from '../Box';
import StackView from '../StackView';

function Item(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'surface' : _ref$backgroundColor,
      children = _ref.children,
      disabled = _ref.disabled,
      _ref$highlightedColor = _ref.highlightedColor,
      highlightedColor = _ref$highlightedColor === void 0 ? 'highlight' : _ref$highlightedColor,
      isHighlighted = _ref.isHighlighted,
      renderLeft = _ref.renderLeft,
      renderRight = _ref.renderRight,
      props = _objectWithoutPropertiesLoose(_ref, ["backgroundColor", "children", "disabled", "highlightedColor", "isHighlighted", "renderLeft", "renderRight"]);

  var css = {
    axis: 'horizontal',
    alignment: 'center',
    shrink: 0,
    minHeight: 4,
    fontSize: '14px',
    paddingVertical: 0.75,
    paddingHorizontal: 1,
    whiteSpace: 'nowrap',
    position: 'relative',
    userSelect: 'none',
    backgroundColor: backgroundColor
  };

  if (renderLeft) {
    css.paddingLeft = 4;
  }

  if (renderRight) {
    css.paddingRight = 4;
  }

  if (isHighlighted) {
    css.backgroundColor = highlightedColor;
  }

  if (disabled) {
    css.cursor = 'not-allowed';
    css.opacity = 0.65;
  } else if (props.onClick || props.onDoubleClick || props.onMouseDown || props.onMouseUp) {
    css.cursor = 'pointer';
  }

  return /*#__PURE__*/React.createElement(StackView, _extends({}, css, props), renderLeft && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 4,
    height: "100%",
    position: "absolute",
    top: 0,
    left: "-1px"
  }, typeof renderLeft === 'function' ? renderRight() : /*#__PURE__*/cloneElement(renderLeft, {
    size: renderLeft.props && renderLeft.props.size || 'md'
  })), children, renderRight && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 4,
    height: "100%",
    position: "absolute",
    top: 0,
    right: "-1px"
  }, typeof renderRight === 'function' ? renderRight() : /*#__PURE__*/cloneElement(renderRight, {
    size: renderRight.props && renderRight.props.size || 'md'
  })));
}

export default Item;